import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ClientOnExcursionService from '../../../repository/clientOnExcursionRepository/ClientOnExcursionRepository';
import '../../../App.css';
import AddClientToExcursionForm from './AddClientToExcursionForm';
import { ReactComponent as ArrowBack } from '../../../assets/icons/ArrowBack.svg';
import ClientExcursionHistory from './ClientExcursionHistory';
import ClientService from '../../../repository/clientRepository/ClientRepository';
import { strings } from '../../../localization/Localization';

const ClientDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [selectedClientDetails, setSelectedClientDetails] = useState({});
  const [excursionsHistory, setExcursionsHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setSelectedClientDetails(location.state?.selectedClientDetails || {})
    if (selectedClientDetails.id) {
      fetchExcursionHistory(selectedClientDetails.id, page, pageSize);
    }
  }, [selectedClientDetails.id, page, pageSize]);

  const fetchExcursionHistory = async (clientId, currentPage, size) => {
    try {
      setLoading(true);
      const response = await ClientOnExcursionService.getAllExcursionsByClientId(clientId, currentPage, size);
      setExcursionsHistory(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching excursion history:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setPage(0);
  };

  const fetchClientForPointsUpdate = (id) => {
    return ClientService.getClientById(id)
      .then((data) => {
        setSelectedClientDetails(data.data);
        return data.data;
      }).catch((error) => {
        console.error('Error fetching client:', error);
        return null;
      });
  };

  return (
    <div className='container mt-4'>
      <div className='row'>
        <div className='col-4'>
          <div>
            <div className='d-flex mb-4'>
              <a className='me-3 cursor-pointer' onClick={() => navigate(-1)}>
                <ArrowBack width='40px' height='40px' />
              </a>
              <h2>{strings.clientDetails}</h2>
            </div>
            <div className='client-details'>
              {[
                { label: strings.name, value: selectedClientDetails.name },
                { label: strings.surname, value: selectedClientDetails.surname },
                { label: strings.passportNumber, value: selectedClientDetails.passportNumber },
                { label: strings.identityCard, value: selectedClientDetails.cardId },
                { label: strings.address, value: selectedClientDetails.address },
                { label: strings.dateOfBirth, value: selectedClientDetails.dateOfBirth },
                { label: strings.phoneNumber, value: selectedClientDetails.phoneNumber },
                { label: strings.email, value: selectedClientDetails.email },
                { label: strings.loyaltyStatus, value: selectedClientDetails.loyaltyStatus },
                { label: strings.points, value: selectedClientDetails.points ?? 0},
              ].map(({ label, value }) => (
                <div key={label} className='d-flex mb-2'>
                  <label className='fw-bold me-2'>{label}:</label>
                  <p className='mb-0'>
                    {value !== undefined && value !== null ? value : <i className='text-secondary'>{strings.noData}</i>}
                  </p>                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='col-8 mt-4'>
          <AddClientToExcursionForm
            client={selectedClientDetails}
            getExcursionHistory={() => fetchExcursionHistory(selectedClientDetails.id, page, pageSize)}
            fetchClientForPointsUpdate={fetchClientForPointsUpdate}
          />
        </div>
      </div>

      <div className='row my-4'>
        <ClientExcursionHistory
          excursionsHistory={excursionsHistory}
          loading={loading}
          onFetchExcursionHistory={fetchExcursionHistory}
          client={selectedClientDetails}
          page={page}
          pageSize={pageSize}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          fetchClientForPointsUpdate={fetchClientForPointsUpdate}
        />
      </div>
    </div>
  );
};

export default ClientDetails;